export const collections = [
  {
    id: "classic",
    title: "古典风月 · 年代情仇",
    description: "深宅大院、家族兴衰与人情冷暖，写给爱看古典叙事的你。",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20abstract%20collage%20art%20of%20Chinese%20classical%20romance%2C%20silk%20fans%2C%20paper%20lanterns%2C%20plum%20blossoms%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20tones%2C%20cinematic%20texture%2C%20refined%20and%20tasteful%2C%20painterly%20illustration%2C%20high%20detail%2C%20balanced%20composition&width=1200&height=800&seq=coll-01&orientation=landscape",
    query: "古装",
  },
  {
    id: "suspense",
    title: "谍影迷城 · 悬疑推理",
    description: "迷雾重重的旧案与新局，层层反转，一次看到过瘾。",
    image:
      "https://readdy.ai/api/search-image?query=Moody%20abstract%20crime%20mystery%20key%20art%2C%20rain%20soaked%20city%20lights%2C%20lone%20silhouettes%2C%20drifting%20smoke%2C%20deep%20navy%20blue%20and%20warm%20amber%20accents%2C%20cinematic%20texture%2C%20refined%20and%20tasteful%2C%20painterly%20illustration%2C%20high%20detail%2C%20balanced%20composition&width=1200&height=800&seq=coll-02&orientation=landscape",
    query: "悬疑",
  },
  {
    id: "wuxia",
    title: "江湖侠义 · 快意恩仇",
    description: "一把刀、一壶酒、一诺千金，重温快意江湖的热血与浪漫。",
    image:
      "https://readdy.ai/api/search-image?query=Dynamic%20wuxia%20martial%20arts%20key%20art%2C%20swirling%20ink%20brush%20strokes%2C%20distant%20mountain%20peaks%2C%20lone%20sword%20silhouette%2C%20deep%20navy%20blue%20and%20warm%20amber%20gold%20tones%2C%20cinematic%20texture%2C%20refined%20and%20tasteful%2C%20painterly%20illustration%2C%20high%20detail%2C%20balanced%20composition&width=1200&height=800&seq=coll-03&orientation=landscape",
    query: "武侠",
  },
];